import { Users } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { initializeFilterData, virtualPath } from "../../CommonComponents/EnvConfig";
import { AutoCompleteBoxNew, FormButton, InputBox, SelectInputBox, TextareaBox } from "../../CommonComponents/InputBox";
import { OperationalTable } from '../../CommonComponents/OperationalTable';

const ReassignLead = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [formData, setFormData] = useState({
        leadNo: "",
        leadManager: "",
        leadStatus: "All",
        newLeadManager:"",
        reason:"",
    });


    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...formData,
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/LeadEntry/GetReAssign`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
        } else if (res.Status === 'ERROR') {
            await NotificationSound(res.Status, res.Message, res.Focus, inputrefs);
            setTableData([]);
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.Focus, inputrefs);
        }
    }

    //--handleApproval--//
    const handleApproval = (value) => {
        window.open(`${virtualPath}/LeadEntry/LeadEntryFollowUp?LeadNo=${value}`, "_blank");
    }

    const handleFollowUp = (value) => {
        window.open(`${virtualPath}/LeadEntry/LeadEntryFollowUp?LeadNo=${value}`, "_blank");
    }

    const handleClear = () => {
        setFormData({
            leadNo: "",
            leadManager: "",
            status: ""
        })
        filterData.SearchText = ''
        inputrefs.current['txtLeadNo'].focus()
        setTableData([])
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };


    const handleReassignLead = async () => {
        const selectedLeads = tableData?.Data?.filter(item => item.checkStatus)
            ?.map(item => item["Lead No"]) || [];

        if (selectedLeads.length === 0) {
            NotificationSound("ERROR", "No Record to Select Lead No");
            return;
        }

        const payload = {
            ...formData,
            leadNo: selectedLeads.join(',') 
        };
        setIsLoading(true);
        let res = await ApiCall(`/api/LeadEntry/ReAssign`, payload);
        if (res.status === 'SUCCESS') {
            await NotificationSound(res.status, res.message);
        } else if (res.status === 'ERROR') {
            await NotificationSound(res.status, res.message, res.focus, inputrefs);
        }

        setIsLoading(false);
    };


    const handleCheckAll = (value) => {
        const updatedData = tableData?.Data?.map(item => ({
            ...item,
            checkStatus: value
        }));

        setTableData({ ...tableData, Data: updatedData });
    };

    const handleCheck = (checked, leadNo, index) => {
        const updatedData = [...tableData.Data];

        updatedData[index].checkStatus = checked;

        setTableData({ ...tableData, Data: updatedData });
    };

    useEffect(() => {
        inputrefs.current['txtLeadNo'].focus()
        document.title = 'Re-Assign Lead'
        //getGroupMasterData()
    }, [sortConfig]);

    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-2'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <Users className="w-6 h-6 text-teal-600" />
                        <h2 className="text-xl font-semibold text-gray-800">Re-Assign Lead</h2>
                    </div>
                </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-white shadow-md rounded-xl p-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

                                <InputBox
                                    labelclass='form-label mb-0 d-flex'
                                id="txtLeadNo"
                                divclassname='col-md-12'
                                    type="text"
                                label="Lead"
                                    placeholder="Enter Lead No"
                                    maxLength='25'
                                    value={formData.leadNo}
                                   
                                    onChange={(e) => {
                                        setFormData({ ...formData, leadNo: e.target.value });
                                    }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current["txtLeadManager"].focus(); };
                                }}
                                    inputrefs={inputrefs}
                                />
                            <AutoCompleteBoxNew 
                                    divclassname='col-md-12'
                                    id="txtLeadManager"
                                    placeholder="Enter Lead Manager"
                                    label='Lead Manager'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtStatus"].focus(); };
                                    }}
                                    autocompleteType='GetLeadManager'
                                    value={formData.leadManager || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, leadManager: newInputValue })
                                        }
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 38,        
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "4px 10px", 
                                        fontSize: "15px"
                                    }
                                }}
                                />

                                <SelectInputBox
                                id="txtStatus"
                                divclassname='col-md-12'
                                value={formData.leadStatus}
                                    label='Status'
                                onChange={(e) => setFormData({ ...formData, leadStatus: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtbtnSub'].focus()
                                        }
                                    }}
                                >
                                    <option value='All'>All</option>
                                    <option value='UnAssigned'>UnAssigned</option>

                                </SelectInputBox>

                            </div>

                        <div className='card-body'>
                            <FormButton
                                id={'txtbtnSub'}
                                inputrefs={inputrefs}
                                handleSearch={getGroupMasterData}
                                save={false}
                                search={true}
                                Export={false }
                                handleClear={handleClear}
                            />
                        </div>
                    </div>

                    <div className="bg-white shadow-md rounded-xl p-4">

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                                <AutoCompleteBoxNew
                                    divclassname='col-md-12'
                                    id="txtNewLeadManager"
                                    placeholder="Enter New Lead Manager"
                                    label='New Lead Manager'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtReason"].focus(); };
                                    }}
                                    required={true}
                                    autocompleteType='GetLeadManager'
                                    value={formData.newLeadManager || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, newLeadManager: newInputValue })
                                        }
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 38,
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "4px 10px",
                                        fontSize: "15px"
                                    }
                                }}
                                />

                                <TextareaBox
                                    id="txtReason"
                                placeholder="Enter Reason"
                                    autoComplete="off"
                                    maxLength='250'
                                label='Reason'
                                    value={formData.reason}
                                onChange={(e) => setFormData({ ...formData, reason: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtRequirements'].focus()
                                        }
                                    }}
                                    rows="1"
                                    divclassname='col-md-12'
                                />

                                <div className='card-body'>
                                    <FormButton
                                    //id={'txtbtnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleReassignLead}
                                    Reset={false}
                                    Export={false }
                                    />
                                </div>

                            </div>
                        </div>


                </div>
            </div>



         

            <div className="mt-3">
                <OperationalTable 
                    loading={isLoading}
                    PageName={'ReassignLead'}
                    handleFilter={() => {
                        getGroupMasterData(1)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                    Filter={false}
                    onlyFilterPage={true}
                    handleFollowUp={handleFollowUp}
                    handleApproval={handleApproval}
                    handleCheckAll={handleCheckAll }
                    handleCheck={handleCheck}
                    CheckAll={selectedLeads}
                />
            </div>
        </>
    )
}
export default ReassignLead;